import { HidableAvatarView } from "@/modules/common/entities/person/person-avatar";
import { ToEmployeeProfileLink } from "@/modules/profile/pages/employee-profile";
import Text from "@/shared/typography/text";
import { PersonLabelFragment } from "gql/graphql";
import { PersonName } from "@/modules/common/entities/person/person-name";
import { ReactNode } from "react";
import { Position } from "@/modules/common/entities/company-structure/position";
import { Nothing } from "@/shared/value";

export type PersonLabelViewProps = {
  data: PersonLabelFragment;
  size?: "small" | "default" | "large";
  extra?: ReactNode;
};

export function PersonLabelView({
  data,
  size = "small",
  extra,
}: PersonLabelViewProps) {
  return (
    <div className="flex min-w-0 gap-x-2">
      <div>
        <HidableAvatarView data={data.avatar} size={size} />
      </div>

      <div className={"flex align-self-center min-w-0 flex-col"}>
        <span className={"ellipsis leading-none"}>
          <ToEmployeeProfileLink id={data.id}>
            <Text
              as="span"
              type={size === "small" ? "body2" : "body1"}
              color="inherit"
            >
              <PersonName data={data} />
            </Text>
          </ToEmployeeProfileLink>
        </span>
        <span className={"ellipsis"}>
          <Text as={"span"} color={"secondary"} type={"caption"}>
            <Position.Name data={data.position} whenEmpty={Nothing} />{" "}
            {extra && <span> • {extra}</span>}
          </Text>
        </span>
      </div>
    </div>
  );
}
